/**
 * Open Transcript block for Podcasts if the link is clicked.
 *
 */
export default function podcastTranscriptOpen(checkbox) {
  const isChecked = checkbox.checked;
  const anchorLink = document.querySelector('.view-transcript-anchor-link');

  const openTranscript = () => {
    if (! isChecked) {
      // eslint-disable-next-line no-param-reassign
      checkbox.checked = true;
    }
  };

  anchorLink.addEventListener('click', openTranscript());
}
